import ms from 'ms'
import {
  curry,
  filter,
  last,
  lt,
  pathEq,
  pathOr,
  pipe,
  propOr,
  sortBy,
} from 'ramda'

const END_BUFFER_THRESHOLD = ms('180m')

export const getActiveRegistrations = curry((programId, registrations) =>
  pipe(
    filter(pathEq(['program', 'id'], programId)),
    filter(
      pipe(
        pathOr([], ['registrationOption', 'schedule']),
        sortBy(
          pipe(propOr('', 'startTime'), (dateString) => new Date(dateString)),
        ),
        last,
        propOr('', 'startTime'),
        (dateString) => new Date(dateString),
        (lastSessionTime) =>
          lastSessionTime.getTime() + END_BUFFER_THRESHOLD > Date.now(),
      ),
    ),
  )(registrations),
)

export const isRegistered = (programId, registrations) =>
  pipe(
    getActiveRegistrations(programId),
    propOr(0, 'length'),
    lt(0),
  )(registrations)
